import { useEffect } from "react";
import {
  useCreateSubscriptionWellnessPlan,
} from "../../../../services/create-subscription-wellnessplan/create-subscription-wellnessplan.service";
import { userActivityLogger } from "../../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import { getSpeciesName } from "../../../../components/PageTitle/WellnessPlanTitle/WellnessPlanTitle";
import { formatBirthdate, getPrices } from "../helpers";
import { IPetItemResponse } from "../../../../services/pet-list/pet-list.interface";
import { FlattenedPlanData } from "../../../../hooks/useWellnessPlans";
import { ICreateSubscriptionWellnessPlanResponse }
  from "../../../../services/create-subscription-wellnessplan/create-subscription-wellnessplan.interface";

interface IUsePurchaseParams {
  petId: string | null;
  currentPet: IPetItemResponse[];
  wellnessPurchaseData: FlattenedPlanData | null;
  billingCycle: "perYear" | "perMonth";
  prices: ReturnType<typeof getPrices>;
  handleModals: (response: ICreateSubscriptionWellnessPlanResponse) => void;
}

export const useWellnessPurchase = ({
  petId,
  currentPet,
  wellnessPurchaseData,
  billingCycle,
  prices,
  handleModals,
}: IUsePurchaseParams) => {
  const {
    createSubscription,
    response,
    loading: createSubscriptionLoading,
    error,
    reset: resetCreateSubscription,
  } = useCreateSubscriptionWellnessPlan();

  useEffect(() => {
    if (response && currentPet?.[0]) {
      if (response?.success) {
        const wellnessUtm = JSON.parse(
          localStorage.getItem("wellness-utm") || "{}",
        );

        const customUTMParams = {
          utm_source: wellnessUtm.utmSource,
          utm_medium: wellnessUtm.utmMedium,
          utm_campaign: wellnessUtm.utmCampaign,
          utm_content: wellnessUtm.utmContent,
        };

        const formattedBirthdate = formatBirthdate(currentPet[0].birthdate);

        userActivityLogger(MIXPANEL_EVENTS.WP_PURCHASE_SUCCESS, {
          pet_id: petId,
          pet_name: currentPet[0].name,
          species: getSpeciesName(currentPet[0].species),
          wellnessPlanCode: wellnessPurchaseData?.planCode,
          total_amount:
            prices[billingCycle].amount! + prices[billingCycle].enrollmentFee!,
          plan_type: billingCycle === "perYear" ? "Annual" : "Monthly",
          selected_plan: wellnessPurchaseData?.planType,
          ...customUTMParams,
          dob: formattedBirthdate,
        });

        localStorage.removeItem("wellness-utm");
        handleModals(response);
      } else {
        userActivityLogger(MIXPANEL_EVENTS.WP_PURCHASE_FAILURE, {
          pet_id: petId,
          pet_name: currentPet[0].name,
          species: getSpeciesName(currentPet[0].species),
          wellnessPlanCode: wellnessPurchaseData?.planCode,
          error_message: response.messages[0],
          selected_plan: wellnessPurchaseData?.planType,
          plan_type: billingCycle === "perYear" ? "Annual" : "Monthly",
        });
      }
    }
  }, [response]);

  return {
    createSubscription,
    createSubscriptionLoading,
    error,
    resetCreateSubscription,
  };
};

